export default __webpack_public_path__ + "static/media/pvilla7-3.5549de23.webp";